// 32-bit powers of two wouldn't be possible with <<
export var p2 = [];
for (var i = 0; i < 32; i++)
    p2[i] = Math.pow(2, i);
